module.exports = __webpack_public_path__ + "img/icon-close.a979982a.svg";